import { getCookie } from 'cookies-next'
import { IncomingMessage, ServerResponse } from 'http'

export const clientGetToggleFromCookie = (toggle: string): boolean => {
	const toggleCookie = getCookie('toggles') as string | undefined

	if (!toggleCookie) {
		return false
	}

	try {
		const parsed = JSON.parse(toggleCookie) as string[]
		return parsed.includes(toggle)
	} catch {
		return false
	}
}

export const getToggleFromCookie = async (
	toggle: string,
	req: IncomingMessage,
	res: ServerResponse
): Promise<boolean> => {
	const toggleCookie = (await getCookie('toggles', { req, res })) as
		| string
		| undefined

	if (toggleCookie) {
		try {
			const parsed = JSON.parse(toggleCookie) as string[]
			return !!parsed.includes(toggle)
		} catch {
			// invalid cookie, fall through to getToggles
		}
	}

	const { getToggles } = await import('@/services/toggleService')
	const toggles = await getToggles()
	const toggleNames = toggles.map((x) => x.name)
	return toggleNames.includes(toggle)
}

export default clientGetToggleFromCookie
